import { useDocumentTitle } from "../hooks/useDocumentTitle";

export function LegalPage({ variant }: { variant: "privacy" | "terms" }) {
  useDocumentTitle(variant === "privacy" ? "Privacy — Pilot Mastery Academy" : "Terms — Pilot Mastery Academy");

  if (variant === "privacy") {
    return (
      <div className="mx-auto max-w-3xl px-4 py-16">
        <h1 className="font-display text-4xl font-semibold text-white">Privacy policy</h1>
        <p className="mt-6 text-sm text-slate-500">Placeholder — replace with counsel-approved policy before launch.</p>
        <div className="mt-8 space-y-4 text-slate-400">
          <p>
            Describe what you collect (email, payment metadata, analytics), lawful bases, retention, subprocessors
            (Stripe, SendGrid, hosting), and contact for requests.
          </p>
          <p>Link your cookie banner and regional addenda (GDPR/CCPA) as required.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <h1 className="font-display text-4xl font-semibold text-white">Terms of service</h1>
      <p className="mt-6 text-sm text-slate-500">Placeholder — replace with counsel-approved terms before launch.</p>
      <div className="mt-8 space-y-4 text-slate-400">
        <p>
          Cover educational-only positioning for tax and career content, refund policy, cohort scheduling, code of conduct
          for communities, and limitation of liability.
        </p>
      </div>
    </div>
  );
}
